import React from 'react';

import { withConfig, withGridConfig } from '../common/Block.jsx';
import { EmptyContentPlaceholder, EmptyPlaceholder } from '../layout/Builder.jsx';
import { Column, Row, Spaced } from '../common/Container.jsx';
import { default as Image, ImageSrcSet, withHoverEffects } from '../common/Image.jsx';
import Layout from '../common/Layout.jsx';
import { ContentContainer } from '../common/List.jsx';
import { ImageGalleryModal } from '../common/Popup.jsx';
import ScreenSize from '../common/ScreenSize.jsx';
import Utilities from '../common/Utilities.jsx';

const defaultColumnCount = 4;

function _ImageGallery(props) {
    const [id, setId] = React.useState(undefined);
    React.useEffect(() => setId(props.blockIdentifier), []);

    const [modal, setModal] = React.useState(undefined);
    const handleClick = (index) => {
        setModal({
            index: index,
            visible: true
        });
    }
    let data;
    let columnCount = props.columnCount || defaultColumnCount;
    if (props.blockConfig) {
        if (props.blockConfig.ids) {
            data = props.blockConfig.ids.map((d, i) => ({
                image: {
                    id: d,
                    caption: i < props.blockConfig.captions.length && props.blockConfig.captions[i],
                    extension: i < props.blockConfig.extensions.length && props.blockConfig.extensions[i],
                }
            }));
        } else if (props.blockConfig.images) {
            data = props.blockConfig.images
        }
        if (props.blockConfig.block) {
            switch (props.screenSize) {
                case ScreenSize.Mobile:
                    columnCount = props.blockConfig.block.columnsPhone || 2;
                    break;
                case ScreenSize.Tablet:
                    columnCount = props.blockConfig.block.columnsTablet || 3;
                    break;
            }
        }
    }
    let hasImage = false;
    let content;
    if (data) {
        const columnSize = Layout.columnSize(columnCount);
        content = data.map((d, i) => {
            if (d.image && d.image.id && d.image.extension) {
                hasImage = true;
            }
            return (
                <ImageGalleryCell
                    {...props}
                    key={i}
                    columnCount={columnCount}
                    columnSize={columnSize}
                    data={d}
                    index={i}
                    listData={data}
                    onClick={() => handleClick(i)} />
            );
        });
    }
    if (!hasImage) {
        if (props.builder) {
            if (props.legacy) {
                return <EmptyContentPlaceholder>This image gallery doesn't have any images yet, but you can add them under the blue settings wheel.</EmptyContentPlaceholder>
            }
            const containerStyle = { width: '100%' };
            Utilities.copyObject(props.containerStyle, containerStyle);
            return <EmptyContentPlaceholder containerStyle={containerStyle} style={props.style}>This image gallery doesn't have any images yet, but you can add them under the Images section.</EmptyContentPlaceholder>
        }
        return null;
    }
    let elementId;
    if (id) {
        elementId = `image-gallery-${id}`;
    }
    return (
        <React.Fragment>
            <div className="cont--kit__wrapper" style={props.containerStyle}>
                <div id={elementId} className="cont--image__gallery">
                    <ContentContainer className={!props.inLayout ? "cont--kit__content" : undefined} style={props.style}>
                        <Spaced>
                            <Row className="cont__row--custom">{content}</Row>
                        </Spaced>
                    </ContentContainer>
                </div>
                {
                    props.builder &&
                    !hasImage &&
                    <EmptyPlaceholder />
                }
            </div>
            {
                modal &&
                modal.visible &&
                <ImageGalleryModal
                    activeIndex={modal.index}
                    builder={props.builder}
                    config={props.config}
                    data={data}
                    onClose={() => setModal(undefined)} />
            }
            {/* <JsonLD
                    baseUrl={props.baseUrl}
                    builder={props.builder}
                    jsonLD={props.jsonLD}
                    path="image"
                    querySub={props.querySub} /> */}
        </React.Fragment>
    );
}
const ImageGallery =
    withConfig(
        withGridConfig(_ImageGallery, defaultColumnCount));

function _ImageGalleryCell(props) {
    if (!props.data.image && !props.data.extension) {
        return null;
    }
    const imageTuples = Image.sizes.map(function (d) {
        const imageData = props.data.image || { id: props.data.id, extension: props.data.extension };
        return { size: d, url: Image.url(imageData, d, d, 'c_fill') };
    });
    let style;
    const columnSpacing = Layout.columnSpacing(props.index, props.columnCount, props.columnSpacing);
    if (columnSpacing) {
        if (!style) {
            style = {};
        }
        style.marginLeft = columnSpacing.left;
        style.marginRight = columnSpacing.right;
    }
    if (props.listData && props.lineSpacing) {
        if (Layout.shouldUseLineSpacing(props.index, props.listData.length, props.columnCount)) {
            if (!style) {
                style = {};
            }
            style.marginBottom = props.lineSpacing;
        }
    }
    let image;
    if (imageTuples) {
        image = (
            <ImageSrcSet
                builder={props.builder}
                className="image-gallery__img"
                config={props.config}
                data={{ alt: props.data.caption, title: props.data.caption }}
                imageTuples={imageTuples}
                style={props.hoverImageStyle} />
        );
    }
    if (!props.builder && props.hoverEffectVisible) {
        image = <span style={props.hoverStyle} onMouseEnter={props.onHoverStart} onMouseLeave={props.onHoverEnd}>{image}{props.hoverEffect}</span>
    }
    return (
        <Column size={props.columnSize} className="image-gallery__col col--custom">
            <figure className="image-gallery__fig" style={style} onClick={props.onClick}>
                {image}
            </figure>
        </Column>
    );
}
const ImageGalleryCell = withHoverEffects(_ImageGalleryCell, 'block');

export default { Component: ImageGallery };